module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=md-require-match> *Please select an existing item </span> ";